module.exports = __webpack_public_path__ + "static/media/savio17.fda17b79.jpg";